import axios from "axios";
import * as ActionType from "./showcase.type";
import { apiInstanceFetch } from "../../../util/api";
import { setToast } from "../../../util/toast";

export const getShowcase = () => (dispatch) => {
  apiInstanceFetch
    .get(`showcase`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_SHOWCASE,
        payload: res.showcases,
      });
    })
    .catch((error) => console.error(error));
};

export const createShowcase = (data) => (dispatch) => {
  axios
    .post(`showcase/create`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.CREATE_SHOWCASE,
          payload: res.data.showcase,
        });
        setToast("success", "Showcase created successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const updateShowcase = (data, id) => (dispatch) => {
  axios
    .patch(`showcase/update?showcaseId=${id}`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_SHOWCASE,
          payload: { data: res.data.showcase, id },
        });
        setToast("success", "Showcase updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};

export const deleteShowcase = (id) => (dispatch) => {
  axios
    .delete(`showcase/delete?showcaseId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_SHOWCASE,
          payload: id,
        });
        setToast("success", "Showcase deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log("error", error.message));
};
